"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AggregateReportRowToJSON = exports.AggregateReportRowFromJSONTyped = exports.AggregateReportRowFromJSON = exports.instanceOfAggregateReportRow = void 0;
var runtime_1 = require("../runtime");
var EntityDimensionType_1 = require("./EntityDimensionType");
var ParentEntity_1 = require("./ParentEntity");
var ReportEntityStatus_1 = require("./ReportEntityStatus");
var ReportField_1 = require("./ReportField");
/**
 * Check if a given object implements the AggregateReportRow interface.
 */
function instanceOfAggregateReportRow(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAggregateReportRow = instanceOfAggregateReportRow;
function AggregateReportRowFromJSON(json) {
    return AggregateReportRowFromJSONTyped(json, false);
}
exports.AggregateReportRowFromJSON = AggregateReportRowFromJSON;
function AggregateReportRowFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'entityType': !(0, runtime_1.exists)(json, 'entity_type') ? undefined : (0, EntityDimensionType_1.EntityDimensionTypeFromJSON)(json['entity_type']),
        'entityId': !(0, runtime_1.exists)(json, 'entity_id') ? undefined : json['entity_id'],
        'entityName': !(0, runtime_1.exists)(json, 'entity_name') ? undefined : json['entity_name'],
        'entityStatus': !(0, runtime_1.exists)(json, 'entity_status') ? undefined : (0, ReportEntityStatus_1.ReportEntityStatusFromJSON)(json['entity_status']),
        'parentEntity': !(0, runtime_1.exists)(json, 'parent_entity') ? undefined : (0, ParentEntity_1.ParentEntityFromJSON)(json['parent_entity']),
        'startTime': !(0, runtime_1.exists)(json, 'start_time') ? undefined : (new Date(json['start_time'])),
        'endTime': !(0, runtime_1.exists)(json, 'end_time') ? undefined : (new Date(json['end_time'])),
        'stats': !(0, runtime_1.exists)(json, 'stats') ? undefined : (json['stats'].map(ReportField_1.ReportFieldFromJSON)),
    };
}
exports.AggregateReportRowFromJSONTyped = AggregateReportRowFromJSONTyped;
function AggregateReportRowToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'entity_type': (0, EntityDimensionType_1.EntityDimensionTypeToJSON)(value.entityType),
        'entity_id': value.entityId,
        'entity_name': value.entityName,
        'entity_status': (0, ReportEntityStatus_1.ReportEntityStatusToJSON)(value.entityStatus),
        'parent_entity': (0, ParentEntity_1.ParentEntityToJSON)(value.parentEntity),
        'start_time': value.startTime === undefined ? undefined : (value.startTime.toISOString()),
        'end_time': value.endTime === undefined ? undefined : (value.endTime.toISOString()),
        'stats': value.stats === undefined ? undefined : (value.stats.map(ReportField_1.ReportFieldToJSON)),
    };
}
exports.AggregateReportRowToJSON = AggregateReportRowToJSON;
